import * as Types from '../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ProvingGroundQueryVariables = {
  id: Types.Scalars['String']
};


export type ProvingGroundQuery = (
  { __typename?: 'Query' }
  & { provingGround: Types.Maybe<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode' | 'abbr' | 'specialNote' | 'inactive'>
  )> }
);

export type ProvingGroundDropdownQueryVariables = {};


export type ProvingGroundDropdownQuery = (
  { __typename?: 'Query' }
  & { provingGrounds: Array<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | 'title' | 'abbr' | 'specialNote'>
  )> }
);

export const ProvingGroundDocument = gql`
    query ProvingGround($id: String!) {
  provingGround(id: $id) {
    _id
    title
    countryCode
    abbr
    specialNote
    inactive
  }
}
    `;

    export function useProvingGroundQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProvingGroundQuery, ProvingGroundQueryVariables>) {
      return ApolloReactHooks.useQuery<ProvingGroundQuery, ProvingGroundQueryVariables>(ProvingGroundDocument, baseOptions);
    };
      export function useProvingGroundLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProvingGroundQuery, ProvingGroundQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ProvingGroundQuery, ProvingGroundQueryVariables>(ProvingGroundDocument, baseOptions);
      };
      
export type ProvingGroundQueryHookResult = ReturnType<typeof useProvingGroundQuery>;
export type ProvingGroundQueryResult = ApolloReactCommon.QueryResult<ProvingGroundQuery, ProvingGroundQueryVariables>;
export const ProvingGroundDropdownDocument = gql`
    query ProvingGroundDropdown {
  provingGrounds(filter: {inactive: {EQ: false}}) {
    _id
    title
    abbr
    specialNote
  }
}
    `;

    export function useProvingGroundDropdownQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProvingGroundDropdownQuery, ProvingGroundDropdownQueryVariables>) {
      return ApolloReactHooks.useQuery<ProvingGroundDropdownQuery, ProvingGroundDropdownQueryVariables>(ProvingGroundDropdownDocument, baseOptions);
    };
      export function useProvingGroundDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProvingGroundDropdownQuery, ProvingGroundDropdownQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ProvingGroundDropdownQuery, ProvingGroundDropdownQueryVariables>(ProvingGroundDropdownDocument, baseOptions);
      };
      
export type ProvingGroundDropdownQueryHookResult = ReturnType<typeof useProvingGroundDropdownQuery>;
export type ProvingGroundDropdownQueryResult = ApolloReactCommon.QueryResult<ProvingGroundDropdownQuery, ProvingGroundDropdownQueryVariables>;